module.exports = __webpack_public_path__ + "static/media/profile-img.f030e766.jpg";